// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const TargetHierarchy = lazy(
  () => import('pages/targetConfig/targetHierarchy/targetHierarchy')
);

const TargetHierarchyRoute = (
  <Route path={routeName.targetHierarchy}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.TARGET_HIERARCHY_VIEW}>
          <Suspense fallback={<Loading />}>
            <TargetHierarchy />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default TargetHierarchyRoute;
